type OAuthProvider = 'github' | 'google' | 'discord';

interface OAuthProviderIconProps {
    provider: OAuthProvider;
    className?: string;
}

const DISCORD_ICON_PATH =
    'M20.317 4.369A19.791 19.791 0 0016.558 3c-.162.294-.352.69-.482 1.004a18.27 18.27 0 00-5.987 0A10.96 10.96 0 009.606 3a19.736 19.736 0 00-3.76 1.369C3.47 7.93 2.83 11.403 3.151 14.827a19.9 19.9 0 005.993 3.034 14.29 14.29 0 001.284-2.107 12.94 12.94 0 01-2.024-.978c.17-.124.336-.255.497-.389a13.77 13.77 0 0012.195 0c.162.134.328.265.497.389a12.9 12.9 0 01-2.028.979c.374.74.806 1.442 1.285 2.106a19.86 19.86 0 005.995-3.036c.376-3.968-.643-7.41-2.954-10.458zM9.955 12.728c-1.183 0-2.157-1.085-2.157-2.419 0-1.334.955-2.419 2.157-2.419 1.211 0 2.176 1.095 2.157 2.419 0 1.334-.955 2.419-2.157 2.419zm4.09 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.334.955-2.419 2.157-2.419 1.211 0 2.176 1.095 2.157 2.419 0 1.334-.946 2.419-2.157 2.419z';

export function OAuthProviderIcon({ provider, className = 'h-5 w-5' }: OAuthProviderIconProps) {
    if (provider === 'github') {
        return (
            <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
                <path
                    className="fill-current"
                    d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"
                />
            </svg>
        );
    }

    if (provider === 'google') {
        return (
            <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
        );
    }

    return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
            <path className="fill-current" d={DISCORD_ICON_PATH} />
        </svg>
    );
}
